import { SECTION_TITLE_LAN } from '@/lib/constants/benefitsTextConstants'
import { basicTextColor } from '@/lib/constants/colorConstants'
import {
  Heading,
  HStack,
  Text,
  useColorMode,
  useColorModeValue,
} from '@chakra-ui/react'

const Title = () => {
  const { toggleColorMode: toggleMode, colorMode } = useColorMode()
  const bg = useColorModeValue('white', 'black')

  //const [firstword, secondword] = SECTION_TITLE.split(' ')

  return (
    <HStack justifyContent="center" bg={bg} w="full" py="1.88rem" id="benefits">
      <Heading
        fontSize="2.125rem"
        fontWeight="semibold"
        color={basicTextColor[colorMode]}
      >
        {/* <Text as="span">{`${firstword} `}</Text> */}
        <Text as="span" color="primary">
          {SECTION_TITLE_LAN}
        </Text>
      </Heading>
    </HStack>
  )
}

export default Title
